import React, { useCallback, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import { ResponsiveSheet } from '@/components/ResponsiveSheet'
import { TableNumberController } from '@/components/TableNumber/TableNumberController'
import { findSettingsByOrderingType } from '@/components/VenueV2/utils/venueUtils'
import { useOrderingTypeContext } from '@/contexts/VenueOrderContext'
import { CartLandingQuery, VenueLandingQuery } from '@/gql/graphql'
import { useLoggerLegacy } from '@/hooks/useLogger'

interface Props {
  open: boolean
  venue: VenueLandingQuery['guestVenue']
  cart: CartLandingQuery['getCart']
  onOpenChange: () => void
}

export const TableNumberSheet = ({
  open,
  venue,
  cart,
  onOpenChange,
}: Props) => {
  const { logEventLegacy } = useLoggerLegacy()

  const handleOnSubmit = useCallback(() => {
    logEventLegacy('Updated table number on venue landing page')
    onOpenChange()
  }, [logEventLegacy, onOpenChange])

  const { orderingType } = useOrderingTypeContext()
  const settings = findSettingsByOrderingType({ venue, orderingType })
  const sheetRef = useRef<HTMLDivElement>(null)

  return (
    <ResponsiveSheet
      ref={sheetRef}
      open={open}
      title={
        settings?.tablePromptText || (
          <FormattedMessage
            defaultMessage="What’s your table number?"
            id="eFKMTQ"
          />
        )
      }
      onOpenChange={onOpenChange}
    >
      <div className="p-4">
        <TableNumberController
          onClose={handleOnSubmit}
          number={cart?.tableNumber}
          area={cart?.tableArea}
          portalRef={sheetRef}
        />
      </div>
    </ResponsiveSheet>
  )
}
